import { Rule } from '@webkit/validation/value';

export const email = (customError?: string): Rule<string> => ({
    id: 'email',
    validator: value => {
        if (!value) return true;

        // Match against allowed characters and structure
        const pattern =
            /^(?!.*(\.\.|--|\+\+))[a-zA-Z0-9](\.|\+|[-_]?)*[a-zA-Z0-9]*([._+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
        return pattern.test(value);
    },
    error: (value?: string) => {
        if (customError) return customError;
        if (!value) return 'Enter email';

        if (!value.includes('@')) return 'Missing "@" symbol';

        const [local, domain] = value.split('@');

        if (!domain) return 'Missing part after "@"';
        if (!local) return 'Missing part before "@"';
        if (local.includes('..') || local.includes('--') || local.includes('++')) {
            return 'Too many repeated symbols';
        }

        if (!/^[a-zA-Z0-9]/.test(local)) return 'Must start with letter or number';

        if (!/\.[a-zA-Z]{2,}$/.test(domain)) return 'Ending must be like ".com" or ".org"';

        return 'Invalid email address';
    },
});

export function isValidEmail(value: string): boolean {
    return email().validator(value);
}

export function getEmailValidationError(value?: string): string {
    return email().error(value);
}

export function isLikeEmail(value: string): boolean {
    if (typeof value !== 'string') return false;

    // Reject purely numeric strings
    if (!isNaN(Number(value))) return false;

    // Definitely email if it includes "@"
    if (value.includes('@')) return true;

    // Also treat as email if it ends in something like ".com", ".org", etc.
    return /\.[a-zA-Z]{2,}$/.test(value);
}
